import { ICopyProcessoRiscosUseCase } from "../../../presentation/useCases/create/copy_processo_riscos_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// CopyrocessoRiscosUseCase

export class CopyrocessoRiscosUseCase implements ICopyProcessoRiscosUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async copyProcessoRiscos(IdProcesso: number, Ano: string): Promise<void> {
    
    await this.repository.copyProcessoRiscos(IdProcesso, Ano);
  }
}